export default __webpack_public_path__ + "static/media/background.0186ccf6.jpg";